import { RecapVideoContentVideoProps } from "./types";

const RecapVideoContentVideo = ({ videoUrl }: RecapVideoContentVideoProps) => {
	return (
		<video
			style={{
				display: "flex",
				flex: 1,
				overflow: "hidden",
				pointerEvents: "none",
			}}
			autoPlay
			controls={false}
			muted
			loop
			playsInline
		>
			<source src={videoUrl} type="video/mp4" />
			Your browser does not support the video tag.
		</video>
	);
};
export default RecapVideoContentVideo;
